<template>
  <div>
    <div class="w-full h-full flex flex-col justify-center items-end">
      <div
        class="transition-colors"
        :class="[isActive ? 'text-white' : 'text-black']"
      >
        KARTVISNING
      </div>
      <div class="flex justify-end items-center cursor-pointer">
        <div
          :class="{ 'bg-green': isActive }"
          class="w-20 h-8 relative flex items-center bg-gray-300 rounded-full px-1"
          @click="changeVal"
        >
          <span
            class="absolute transition-all user-"
            :class="{
              'text-white left-2': isActive,
              'text-black right-2': !isActive
            }"
          >
            {{ `${isActive ? "PÅ" : "AV"}` }}
          </span>
          <div
            class="bg-white w-5 h-5 rounded-full shadow-md transform transition-transform"
            :class="{ 'translate-x-12': isActive }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      isActive: this.value
    };
  },
  methods: {
    changeVal() {
      this.isActive = !this.isActive;
      this.$emit("input", this.isActive);
    }
  }
};
</script>
